import BdcShipment from "../components/Bdc/Shipment";

const BdcShipmentPage = () => <BdcShipment />;

export default BdcShipmentPage;
